export default {"src":"/_next/static/image/public/images/ic_express_schedule.94b9e12762b46c1c634e99aeb80d64b0.svg","height":24,"width":82};